import React from 'react'
import MaskedInput from 'react-text-mask'

export function MaskCPF(props) {
	const { inputRef, ...other } = props;
	return (
	  <MaskedInput
		{...other}
		ref={ref => {
		  inputRef(ref ? ref.inputElement : null);
		}}
		mask={[ /[0-9]/,/[0-9]/,/[0-9]/,'.',/[0-9]/,/[0-9]/,/[0-9]/,'.',/[0-9]/,/[0-9]/,/[0-9]/,'-',/[0-9]/,/[0-9]/ ]}
		placeholderChar={'\u2000'}
	  />
	);
}

export function MaskData(props) {
	const { inputRef, ...other } = props;
	return (
	  <MaskedInput
		{...other}
		ref={ref => {
		  inputRef(ref ? ref.inputElement : null);
		}}
		mask={[ /[0-1]/,/[0-9]/,'/',/[0-1]/,/[0-9]/,'/',/[1-9]/,/[0-9]/,/[0-9]/,/[0-9]/ ]}
		placeholderChar={'\u2000'}
	  />
	);
}

export function MaskDataHora(props){
	const { inputRef, ...other } = props;
	return (
	  <MaskedInput
		{...other}
		ref={ref => {
		  inputRef(ref ? ref.inputElement : null);
		}}
		mask={[ /[0-3]/,/[0-9]/,'/',/[0-1]/,/[0-9]/,'/',/[1-9]/,/[0-9]/,/[0-9]/,/[0-9]/,' ',/[0-9]/,/[0-9]/,':',/[0-9]/,/[0-9]/ ]}
		placeholderChar={'\u2000'}
	  />
	);
}

export function MaskCEP(props) {
	const { inputRef, ...other } = props;
	return (
	  <MaskedInput
		{...other}
		ref={ref => {
		  inputRef(ref ? ref.inputElement : null);
		}}
		mask={[/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,'-',/[0-9]/,/[0-9]/,/[0-9]/]}
		placeholderChar={'\u2000'}
	  />
	);
}

export function MaskTelefone(props) {
	const { inputRef, ...other } = props;
	return (
	  <MaskedInput
		{...other}
		ref={ref => {
		  inputRef(ref ? ref.inputElement : null);
		}}
		mask={['(',/[1-9]/,/[1-9]/,')',' ',/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,'-',/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/ ]}
		placeholderChar={'\u2000'}
	  />
	);
}

export function MaskTelefoneDefault(props) {
	const { inputRef, ...other } = props;
	let replace = String(props.value).replace(/[^0-9]+/g, '');
	if (replace.charAt(0) === '0'){
		return (
			<MaskedInput
				{...other}
				ref={ref => {
				inputRef(ref ? ref.inputElement : null);
				}}
				mask={[/[0-0]/,/[8-8]/,/[0-0]/,/[0-0]/,'-',/[0-9]/,/[0-9]/,/[0-9]/,'-',/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/]}
				placeholderChar={'\u2000'}
			/>
		)
	}
	return (
	  <MaskedInput
		{...other}
		ref={ref => {
		  inputRef(ref ? ref.inputElement : null);
		}}
		mask={['(',/[0-9]/,/[1-9]/,')',' ',/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,'-',/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/ ]}
		placeholderChar={'\u2000'}
	  />
	);
}



// WEBPACK FOOTER //
// ./src/utils/mask.js